import ReactTooltip from 'react-tooltip';

const StandardTooltipWindow = ({ text, id, tooltipPlace = 'top' }) => {
    return (
        <ReactTooltip id={id} place={tooltipPlace} type="dark" effect="solid" delayShow={800}>
            {text}
        </ReactTooltip>
    );
};
export { StandardTooltipWindow };

const Tooltip = (props) => {
    const { id, tooltip, children, window } = props;
    return tooltip ? (
        <>
            <a data-tip data-for={id}>
                {children}
            </a>
            {window}
        </>
    ) : (
        <> {children}</>
    );
};
export { Tooltip };
